export default function sluggedText(text) {
    return text === null || text === void 0 ? void 0 : text.toLowerCase().replace(/\s/g, '-');
}
